import React, { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DateForm from "../../../Components/DateForm/DateForm";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { getContext } from "../../../Helpers/Context/Context";
import { LoanStatus } from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import { DropdownTypeId } from "../../../Helpers/Enums/DropdownTypeId";
import { GetMultipleDropdownData } from "../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { GetMultipleDropdownDataResponseModel } from "../../../Models/GetMultipleDropdownDataResponseModel";
import { getStatusIdsForLoanDashboard } from "../Helpers/GridHelper";
import { LoanDashboardModules } from "../../../Helpers/Enums/LoanDashboardModules";

const AllRequestsFilters = (props) => {
  const { activeTab, dashboardFilterOn, setCurrentFilters } = props;
 
  const context = getContext();

  const [statusOption, setStatusOption] = useState([]);
  const [allStatusOption, setAllStatusOption] = useState([]);
  const [status, setStatus] = useState<any>();
  const [typeofApplicant, setTypeofApplicant] = useState<any>(null);
  const [typeofApplicantOptions, setTypeofApplicantOptions] = useState<any>([]);
  const [unitCode, setUnitCode] = useState<any>(null);
  const [unitCodeOptions, setUnitCodeOptions] = useState<any>([]);
  const [formErrors, setFormErrors] = useState({});
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);

  const enum EventTarget {
    TypeOfApplicantOnChange,
    UnitCodeOnChange,
    StatusOnChange,
    FromDateOnChange,
    ToDateOnChange,
    Reset,
    Apply,
  }

  const handleEvents = (target: EventTarget, event: any = null) => {
    switch (target) {
      case EventTarget.TypeOfApplicantOnChange:
        setTypeofApplicant(event);
        break;
      case EventTarget.UnitCodeOnChange:
        setUnitCode(event);
        break;
      case EventTarget.StatusOnChange:
        setStatus(event);
        break;
      case EventTarget.FromDateOnChange:
        setFromDate(event);
        break;
      case EventTarget.ToDateOnChange:
        setToDate(event);
        break;
      case EventTarget.Reset:
        setTypeofApplicant(null);
        setUnitCode(null);
        setStatus(null);
        setFromDate(null);
        setToDate(null);
        const filtersReset = {
          typeofApplicant: null,
          unitCode: null,
          status: null,
          fromDate: null,
          toDate: null,
        };

        setCurrentFilters(filtersReset);
        break;
      case EventTarget.Apply:
        const filtersApply = {
          typeofApplicant,
          unitCode,
          status,
          fromDate,
          toDate,
        };

        setCurrentFilters(filtersApply);
        break;
    }
  };

  const getMultipleDropdownData = async () => {
    const requestBody = {
      dropdowns: [
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.ApplicantType,
        },
        {
          dropdownName: "unitcodedd",
        },
        {
          dropdownName : "loanstatus"
        },
        {
          dropdownName : "loanrepaymentstatus"
        },
      ],
      // dropdownName: [
      //   LoanDashboardModules.AllRepayment,
      //   LoanDashboardModules.PendingRepayment,
      // ].includes(activeTab.module)
      //   ? "loanrepaymentstatus"
      //   : "loanstatus",
    };

    const result = await APICall(GetMultipleDropdownData, requestBody);

    if (result && result.Status === ApiStatus.OK) {
      let mdData = result.Data as Array<GetMultipleDropdownDataResponseModel>;

      for (let index = 0; index < mdData.length; index++) {
        const md = mdData?.[index];
        if (md) {
          switch (md.Name) {
            case "generic":
              switch (md.GenericMasterTypeId) {
                case DropdownTypeId.ApplicantType:
                  setTypeofApplicantOptions(md.Data);
                  break;
              }
              break;
            case "unitcodedd":
              setUnitCodeOptions(md.Data);
              break;
            case "loanrepaymentstatus":
            case "loanstatus":
              setAllStatusOption(md.Data);
              let statusIdArr = getStatusIdsForLoanDashboard(
                activeTab.module,
                context.loggedInAs.value as RoleEnum
              );
              let statusAsPerRole = md.Data.filter((d) =>
                statusIdArr.includes(d.value)
              );
              setStatusOption(statusAsPerRole);
              break;
          }
        }
      }
    }
  };

  useEffect(() => {
    getMultipleDropdownData();
  }, [activeTab]);

  useEffect(() => {
    if (statusOption.length > 0) {
      let statusIdArr = getStatusIdsForLoanDashboard(
        activeTab.module,
        context.loggedInAs.value as RoleEnum
      );
      let statusAsPerRole = allStatusOption.filter((d) =>
        statusIdArr.includes(d.value)
      );
      setStatusOption(statusAsPerRole);
    }
  }, [activeTab.module]);

  return (
    <div>
      <div className="clearfix"></div>
      <Collapse in={dashboardFilterOn}>
        <div className="filter-content pt-2 px-0">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
              <div className="form-group">
                <label className="col-form-label">Type of Applicant</label>
                <SelectForm
                  options={typeofApplicantOptions}
                  placeholder="Type of Applicant"
                  isDisabled={false}
                  value={typeofApplicant}
                  onChange={(event) =>
                    handleEvents(EventTarget.TypeOfApplicantOnChange, event)
                  }
                  isMulti={true}
                  noIndicator={false}
                  noSeparator={false}
                />
                {/* <p style={{ color: "red" }}>
                        {formErrors["typeofApplicant_isEmpty"]}
                      </p> */}
              </div>
            </div>
            {context?.loggedInAs?.value !== RoleEnum.HRHOD && (
              <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">Unit Code</label>
                  <SelectForm
                    options={unitCodeOptions}
                    placeholder="Unit Code"
                    isDisabled={false}
                    value={unitCode}
                    onChange={(event) =>
                      handleEvents(EventTarget.UnitCodeOnChange, event)
                    }
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  {/* <p style={{ color: "red" }}>
                        {formErrors["unitCode_isEmpty"]}
                      </p> */}
                </div>
              </div>
            )}
            <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
              <div className="form-group">
                <label className="col-form-label" style={{ display: "flex" }}>Status</label>
                <SelectForm
                  options={statusOption}
                  isMulti={false}
                  placeholder={"Status"}
                  value={status}
                  onChange={(event: any) =>
                    handleEvents(EventTarget.StatusOnChange, event)
                  }
                />
                <p style={{ color: "red" }}>{formErrors["status_isEmpty"]}</p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
              <div className="form-group">
                <label className="col-form-label">From Date</label>
                <br />
                <div className="">
                  <div className="input-group date selectdate">
                    <DateForm
                      isDisabled={false}
                      value={fromDate}
                      onChange={(e) =>
                        handleEvents(EventTarget.FromDateOnChange, e)
                      }
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                </div>
                {/* <p style={{ color: "red" }}>
                        {formErrors["fromDate_isEmpty"]}
                      </p> */}
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
              <div className="form-group">
                <label className="col-form-label">To Date</label>
                <br />
                <div className="">
                  <div className="input-group date selectdate">
                    <DateForm
                      isDisabled={false}
                      value={toDate}
                      onChange={(e) =>
                        handleEvents(EventTarget.ToDateOnChange, e)
                      }
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                </div>
                {/* <p style={{ color: "red" }}>
                        {formErrors["toDate_isEmpty"]}
                      </p> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 mt-1">
              <div className="float-right">
                <button
                  className="btn btn-cancel"
                  style={{ marginLeft: 5 }}
                  onClick={(e) => handleEvents(EventTarget.Reset, e)}
                >
                 <i className="fas fa-undo"></i> Reset
                </button>
                <button
                  className="btn btn-info"
                  style={{ marginLeft: 5 }}
                  onClick={(e) => handleEvents(EventTarget.Apply, e)}
                >
                 <i className="fas fa-check"></i> Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
      <div className="py-2"></div>
    </div>
  );
};

export default AllRequestsFilters;
